var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"space-loading position-absolute w-100 h-100 d-middle-center"},[_c('lottie-animation',{attrs:{"path":_vm.urlLottie,"speed":1,"loop":true,"width":256,"height":256}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }